import { projectContext } from "@/layouts/MainLayout"
import { deleteEquipmentMenu } from "@/services/admin/equipment-menu/equipmentMenu.services"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { addPropertySetToProject, deletePropertySetFromProject, getAllPropertySets, getProjectPropertySets } from "@/services/project/project"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { useRequest } from "ahooks"
import { Button, Card, Input, List, Modal, Select } from "antd"
import { useContext, useMemo, useState } from "react"

export const ProjectPropertySets = () => {
  const { projectId } = useContext(projectContext)
  const { data: allSets = [] } = useRequest(() => getAllPropertySets())
  const { data = [], loading, refresh } = useRequest(() => getProjectPropertySets({pId: projectId}))

  const diffSets = useMemo(() => {
    return allSets.filter(item => !data.some(selected => selected.id === item.id))
  }, [allSets, data])

  const onAdd = async (setId: string) => {
    await addPropertySetToProject({pId: projectId, id: setId})
    refresh()
  }

  const allItems = data.concat({type: 'add'} as any)
  return <div style={{padding: '10px 0px', width: 600}}>
    <Card
      title='Property Sets'
    >
      <List
        bordered
        loading={loading}
        dataSource={allItems}
        renderItem={(item) => {
          if ((item as any).type === 'add') {
            return <CreateItem sets={diffSets} onAdd={onAdd} />
          }
          return <List.Item>
            <div className="flex-space-btw">
              <div>{item.name}</div>
              <div><Button danger size="small" onClick={() => {
                Modal.confirm({
                  icon: <ExclamationCircleOutlined />,
                  content: 'Are you sure to delete?',
                  onOk: async () => {
                    try {
                      await deletePropertySetFromProject({pId: projectId, id: item.id})
                      refresh()
                      return true
                    } catch (error) {
                      return false
                    }
                  }
                })
              }}>Delete</Button></div>
            </div>
          </List.Item>
        }}
      />
    </Card>
  </div>
}

const CreateItem = (props: {sets: PropertySetModule.Modal[], onAdd: (val: string) => Promise<void>}) => {
  const {onAdd} = props
  const [value, setValue] = useState<string>()
  const options = props.sets.map((item) => {
    return {label: item.name, value: item.id}
  })

  const toAdd = async () => {
    if (!value) return
    await onAdd(value)
    setValue('')
    // 
  }

  return <div className="flex-space-btw p-1">
    <div style={{flex: 8}}><Select value={value} options={options} style={{width: '100%'}} onChange={(val) => {
      setValue(val)
    }}/> </div>
    <div style={{flex: 2, paddingRight: 10, textAlign: 'right'}} >
      <Button size="small" type="primary" disabled={!value} onClick={toAdd}>Add to project</Button>
    </div>
  </div>
}